// test2362
(2362 && 0);
